import { useMediaQuery } from "@mui/material";
import { SimpleShowLayout, TextField, Labeled, ReferenceField, DateField } from "react-admin";
import { Grid } from "@mui/material";
import { settings } from "app";
import { SectionTitle } from "features/SectionTitle";
import { administrationRequests } from "api/administrationApi";

const BasicInfoSection = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  return (
    <SimpleShowLayout>
      <Grid
        container
        spacing={2}
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        <Grid
          item
          xs={12}
        >
          <SectionTitle
            title="Основна информация"
            paddingY={0}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <Labeled label="Име на български">
            <TextField source="nameBg" />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <Labeled label="Име на английски">
            <TextField source="nameEn" />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <Labeled label="Начало на регистрация">
            <DateField
              source="registrationStartsOn"
              locales="bg-BG"
              showTime
            />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <Labeled label="Край на регистрация">
            <DateField
              source="registrationEndsOn"
              locales="bg-BG"
              showTime
            />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <Labeled label="Структурна единица">
            <ReferenceField
              source="structuralUnitId"
              reference={administrationRequests.getStructuralUnitsSelect()}
            >
              <TextField source="name" />
            </ReferenceField>
          </Labeled>
        </Grid>
      </Grid>
    </SimpleShowLayout>
  );
};

export default BasicInfoSection;
